<template>
  <v-form @submit.prevent="$emit('save', activityReport)">
    <v-card>
      <v-card-title>
        {{ $t('edit_activity_report') }}
      </v-card-title>

      <v-card-text>
        <v-row dense>
          <v-col cols="12" sm="6">
            <v-text-field
              v-model="activityReport.title"
              :error-messages="errors['title']"
              :label="formMixin_getRequiredFieldLabel($t('title'))"
              name="title"
              autofocus
              @input="formMixin_clearErrors('title')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-text-field
              v-model="activityReport.year"
              :error-messages="errors['year']"
              :label="formMixin_getRequiredFieldLabel($t('year'))"
              type="number"
              name="year"
              autofocus
              @input="formMixin_clearErrors('year')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <v-checkbox
              v-model="activityReport.is_published"
              :error-messages="errors['is_published']"
              :label="$t('published')"
              @change="formMixin_clearErrors('is_published')"
            />
          </v-col>

          <v-col cols="12" sm="6">
            <BaseFileDropZone
              accept=".jpeg,.jpg,.bmp,.png,.gif,.pdf,.xlsx,.xls,.doc,.docx"
              @drop="
                onFileSelect($event);
                formMixin_clearErrors('file');
              "
            >
              <div v-if="!activityReport.original_name" class="drop-zone">
                <div class="drop-zone-message">
                  <p>{{ $t('pdf_file_drop_zone_message') }}</p>
                </div>
              </div>

              <div v-else class="text-center drop-zone" :class="errors.file ? 'error-outline' : ''">
                <v-icon x-large>mdi-file</v-icon>
                <p class="image-name text-truncate">{{ activityReport.original_name }}</p>
                <p class="pt-3">{{ $t('file_replace_message') }}</p>
              </div>
            </BaseFileDropZone>
            <template v-if="errors.file">
              <div
                v-for="(error, errorIndex) in errors.file"
                :key="errorIndex"
                class="mt-2 v-messages theme--light error--text"
              >
                {{ error }}
              </div>
            </template>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-actions>
        <span class="text-subtitle-2 ml-3"> * {{ $t('must_be_filled') }} </span>

        <v-spacer />

        <v-btn text color="secondary" @click="$emit('preview', activityReport)">{{
          $t('preview')
        }}</v-btn>

        <v-btn text color="primary" @click="$emit('cancel')">
          {{ $t('cancel') }}
        </v-btn>

        <v-btn :disabled="disabled" :loading="disabled" color="primary" text type="submit">
          {{ $t('save') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
import formMixin from '../mixins/form-mixin';
import BaseFileDropZone from './base/BaseFileDropZone';

export default {
  name: 'ActivityReportForm',

  components: { BaseFileDropZone },

  mixins: [formMixin],

  props: {
    activityReport: {
      type: Object,
      required: true,
    },
    errors: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    onFileSelect(file) {
      this.$emit('select:file', file);
    },
  },
};
</script>

<style scoped>
.drop-zone {
  background-color: white;
  outline: 2px dashed darkgray;
  width: 95%;
  height: 100px;
  z-index: 100;
  text-align: center;
  margin: auto;
  position: relative;
}
.drop-zone-message {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
}
.drop-zone-message p,
.image-name {
  color: darkgray;
  margin: 0;
}
</style>
